/* Extracted from the inline <script> in sections/collection-left-nav.liquid (3 of 3: price sort) so browsers can cache it; loaded with defer. */
// Delegated qty-stepper: works for SSR rows and JS-rendered rows alike.
(function () {
  var table = document.getElementById('view-table');
  if (!table) return;

  function clamp(val) {
    val = parseInt(val, 10);
    if (isNaN(val)) val = 1;
    if (val < 1) val = 1;
    if (val > 99) val = 99;
    return val;
  }

  table.addEventListener('click', function (e) {
    var btn = e.target.closest('.pc-t__qty-dec, .pc-t__qty-inc');
    if (!btn || !table.contains(btn)) return;

    var qtyWrap = btn.closest('.pc-t__qty');
    var input = qtyWrap && qtyWrap.querySelector('input[name="quantity"]');
    if (!input) return;

    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = 1;

    if (btn.classList.contains('pc-t__qty-dec')) {
      val -= 1;
    } else {
      val += 1;
    }

    input.value = clamp(val);
  });

  table.addEventListener('change', function (e) {
    var input = e.target.closest('.pc-t__qty-n');
    if (!input || !table.contains(input)) return;
    input.value = clamp(input.value);
  });
})();

// ---- Sort ----
(function () {
  var sortSelect = document.getElementById('pc-sort');
  var priceSortBtn = document.getElementById('pc-price-sort');
  var fitbarEl = document.getElementById('pc-fitbar');
  window.pcCurrentSort = window.pcCurrentSort || '';

  // Vehicle mode is "API-sourced rows are showing", which is
  // no longer the same thing as "the fitbar is visible" - the picker can be
  // open (fitbar hidden) with a vehicle actively selected and under-qualified
  // while its results still render below. renderVehicleRefinements() sets/
  // clears this dedicated attribute on the fitbar independent of `hidden`.
  function isVehicleMode() {
    return !!(fitbarEl && fitbarEl.hasAttribute('data-vehicle-active'));
  }

  function ensureBrandOption(show) {
    if (!sortSelect) return;
    var opt = sortSelect.querySelector('option[value="brand-az"]');
    if (show && !opt) {
      opt = document.createElement('option');
      opt.value = 'brand-az';
      opt.textContent = 'Brand A–Z';
      sortSelect.appendChild(opt);
    } else if (!show && opt) {
      opt.remove();
    }
  }

  // Exposed globally (window.pcSortRows) so renderCatalogLinesFromAPI can re-apply the active
  // sort to freshly (re)rendered rows - e.g. after a sidebar filter change - without this
  // IIFE duplicating any renderer or filter logic.
  window.pcSortRows = function (rows, value) {
    var arr = rows.slice();
    if (value === 'price-ascending') {
      arr.sort(function (a, b) { return (Number(a && a.Availability && a.Availability.price) || 0) - (Number(b && b.Availability && b.Availability.price) || 0); });
    } else if (value === 'price-descending') {
      arr.sort(function (a, b) { return (Number(b && b.Availability && b.Availability.price) || 0) - (Number(a && a.Availability && a.Availability.price) || 0); });
    } else if (value === 'brand-az') {
      arr.sort(function (a, b) { return String((a && a.Brand) || '').localeCompare(String((b && b.Brand) || ''), undefined, { sensitivity: 'base' }); });
    }
    return arr;
  };

  function navigateSort(value) {
    var params = new URLSearchParams(location.search);
    if (value) params.set('sort_by', value); else params.delete('sort_by');
    params.delete('page');
    var qs = params.toString();
    location.assign(location.pathname + (qs ? '?' + qs : ''));
  }

  function updatePriceSortAriaSort(value) {
    var th = priceSortBtn && priceSortBtn.closest('th');
    if (!th) return;
    if (value === 'price-ascending') {
      th.setAttribute('aria-sort', 'ascending');
    } else if (value === 'price-descending') {
      th.setAttribute('aria-sort', 'descending');
    } else {
      th.removeAttribute('aria-sort');
    }
  }

  function handleSortChange(value) {
    if (sortSelect) sortSelect.value = value;
    updatePriceSortAriaSort(value);
    if (isVehicleMode()) {
      window.pcCurrentSort = (value === 'price-ascending' || value === 'price-descending' || value === 'brand-az') ? value : '';
      if (window.pcVehicleBaseRows && typeof renderCatalogLinesFromAPI === 'function') {
        renderCatalogLinesFromAPI({ CatalogLines: window.pcSortRows(window.pcVehicleBaseRows, window.pcCurrentSort), __pcSorted: true });
      }
    } else {
      navigateSort(value);
    }
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', function () { handleSortChange(sortSelect.value); });
  }

  if (priceSortBtn) {
    priceSortBtn.addEventListener('click', function () {
      var current = sortSelect ? sortSelect.value : '';
      var next = (current === 'price-ascending') ? 'price-descending' : 'price-ascending';
      handleSortChange(next);
    });
  }

  // Keep the Brand A-Z option + client-side sort state in sync with vehicle mode via the
  // fitbar's data-vehicle-active attribute (the signal for "vehicle mode is
  // active" - decoupled from `hidden`, which can also mean "picker collapsed"), so this
  // stays independent of the vehicle-select/-clear event wiring elsewhere in the file.
  if (fitbarEl) {
    // Initial state: just sync the Brand A–Z option. Do NOT reset sort state here -
    // at parse time the select still carries the Liquid-rendered `selected` for a
    // deep-linked ?sort_by=, and resetting it here wiped SSR sort state before the
    // price-sort toggle (or a later vehicle-mode transition) ever saw it.
    var pcVehicleModeActive = isVehicleMode();
    ensureBrandOption(pcVehicleModeActive);

    var syncForVehicleMode = function () {
      var active = isVehicleMode();
      var wasActive = pcVehicleModeActive;
      ensureBrandOption(active);
      if (wasActive && !active) {
        // active -> inactive: vehicle mode just turned off; reset client-side sort
        // state so the next vehicle-mode render starts from "Best fit".
        window.pcCurrentSort = '';
        window.pcVehicleBaseRows = null;
        if (sortSelect) sortSelect.value = '';
        updatePriceSortAriaSort('');
      } else if (!wasActive && active) {
        // inactive -> active: vehicle mode just turned on; seed the sticky sort from
        // whatever the select already shows (e.g. the SSR `selected` for a deep-linked
        // ?sort_by=) so the existing __pcSorted sticky path re-applies it to API rows.
        window.pcCurrentSort = (sortSelect ? sortSelect.value : '') || '';
      }
      pcVehicleModeActive = active;
    };
    new MutationObserver(syncForVehicleMode).observe(fitbarEl, { attributes: true, attributeFilter: ['hidden', 'data-vehicle-active'] });
  }
})();
